import React from 'react'

import { Text } from '../typography/Text'

export const Privacy = ({
  children,
  textDecoration = 'none',
  fontWeight = 'bold',
  country,
}: {
  children: any
  textDecoration?: string
  fontWeight?: string
  country?: string
}) => {
  const localePrefix = country === 'US' ? `/en-us` : ''
  const privacyPath = `${localePrefix}/privacy-policy`
  return (
    <a href={privacyPath} target="_blank" rel="noopener noreferrer">
      <Text
        as="span"
        display="inline"
        fontSize="inherit"
        fontWeight={fontWeight}
        textDecoration={textDecoration}
      >
        {children}
      </Text>
    </a>
  )
}
